import { v4 as uuidv4, validate, version } from 'uuid';

// Function to generate a UUID v4
export const generateID = () => {
    return uuidv4();
};

export function isValidID(id) {
    return validate(id) && version(id) === 4;
};